import React, { Fragment, useState } from 'react';

import { MaintenanceListStyles } from './MaintenanceListStyles';
import Loading from '../components/Loading';

const maintenanceListItem = (props, hidePendentes, currentItems) =>
  currentItems
    .filter(maintenance => !(hidePendentes && maintenance.situation === 'PENDENTE'))
    .map(maintenance => (
      <div
        className="item"
        key={maintenance.uuid}
        onClick={e => {
          props.onMaintenanceEdit(maintenance);
        }}
        style={{
          backgroundColor: maintenance.situation === 'PENDENTE' && '#942c24',
          color: maintenance.situation === 'PENDENTE' && 'white',
          fontWeight: maintenance.situation === 'PENDENTE' && 'bold',
        }}
      >
        <p className="code">{maintenance.equipment.code}</p>
        <p className="type">{maintenance.type}</p>
        <p className="situation">{maintenance.situation}</p>
        <p className="date">
          {new Date(maintenance.opening_date).toLocaleString('pt-BR', {
            timeZone: 'UTC',
          })}
        </p>
        <p className="date_end">
          {maintenance.closing_date
            ? new Date(maintenance.closing_date).toLocaleString('pt-BR', {
                timeZone: 'UTC',
              })
            : ''}
        </p>
        <p className="situation">{maintenance.opening_description}</p>
      </div>
    ));

function MaintenanceList(props) {
  const { loadingList, maintenances } = props;
  const [hidePendentes, setHidePendentes] = useState(false);

  const [pageIndex, setPageIndex] = useState(0);
  const itemsPerPage = 14;

  const filteredMaintenances = maintenances
    ? maintenances.filter(m => !(hidePendentes && m.situation === 'PENDENTE'))
    : [];

  const start = pageIndex * itemsPerPage;
  const end = start + itemsPerPage;
  const currentItems = filteredMaintenances.slice(start, end);

  const toggleHidePendentes = () => {
    setHidePendentes(!hidePendentes);
    setPageIndex(0);
  };

  return (
    <Fragment>
      <hr style={{ width: '90%', marginTop: '20px', marginBottom: '20px' }} />

      {!loadingList ? (
        filteredMaintenances && filteredMaintenances.length > 0 ? (
          <Fragment>
            <header style={{ width: '90%', margin: '0 auto 10px auto', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div className="pagination-buttons">
                <button
                  type="button"
                  onClick={() => setPageIndex(Math.max(pageIndex - 1, 0))}
                  disabled={pageIndex === 0}
                  style={{
                    marginRight: '10px',
                    backgroundColor: pageIndex === 0 && '#ccc',
                  }}
                >
                  ◀
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setPageIndex(Math.min(pageIndex + 1, Math.ceil(filteredMaintenances.length / itemsPerPage) - 1))
                  }
                  disabled={pageIndex >= Math.ceil(filteredMaintenances.length / itemsPerPage) - 1}
                  style={{
                    backgroundColor:
                      pageIndex >= Math.ceil(filteredMaintenances.length / itemsPerPage) - 1 && '#ccc',
                  }}
                >
                  ▶
                </button>
              </div>
              <div style={{ width: '90%', margin: '0 0 20px 0', textAlign: 'right' }}>
                <label style={{ fontSize: '0.9rem' }}>
                  <input
                    type="checkbox"
                    checked={hidePendentes}
                    onChange={toggleHidePendentes}
                  />{' '}
                  Ocultar pendentes
                </label>
              </div>
            </header>

            <MaintenanceListStyles>
              {maintenanceListItem(props, hidePendentes, currentItems)}
            </MaintenanceListStyles>
          </Fragment>
        ) : (
          'LISTA VAZIA'
        )
      ) : (
        <Loading />
      )}

      <hr style={{ width: '90%', marginTop: '20px' }} />
    </Fragment>
  );
}

export default MaintenanceList;
